<template>
  <div>
    <!-- Mount point for TextSnippetModal -->
    <div
      v-if="show"
      id="TextSnippetModal"
      ref="textSnippetModalApp"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import AppState from '../../../states/app'

const textSnippetModalApp = ref()

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  onCancel: {
    type: Function,
    required: true,
  },
  onSuccess: {
    type: Function,
    required: true,
  },
})

// Watch for show prop changes to mount/unmount the modal
watch(
  () => AppState.showTextSnippetModal,
  async (newValue) => {
    if (newValue) {
      const eventName = AppState.editingTemplateData ? 'open-text-snippet-modal-edit' : 'open-text-snippet-modal'
      AppState.parentApp?.then(parent => {
      parent.emit(eventName, JSON.parse(JSON.stringify(AppState.editingTemplateData)))
    })
    }
  }
)
</script>
